import _util from '../../utils/';


const recruitmentStatisticsService = {
	selectRecruitmentStatistics(gets, resolve, reject) {
		_util.request({
			url: '/api/HROffersRequirementStatistics/Get',
			params: gets,
			success: resolve,
			error: reject
		})
	},
};


export default recruitmentStatisticsService;


// WEBPACK FOOTER //
// ./src/services/Recruitment/recruitment-statistics-service.js